module.exports = __webpack_public_path__ + "0ef840d8c2186dee297133c3d7936670.png";